/* eslint-disable @reatom/unit-naming-rule */
import { action, atom } from '@reatom/framework'

import { AsyncStateN } from '@blade/std-lib'
import {
  Network,
  networkDataByNetworkStateAtom,
  selectedNetworkAtom,
} from '@root/entities/network'
import { pairPriceUpdateEvent } from '@root/entities/realtime'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { reatomBigNumber } from '@root/shared/lib'

import type { BigNumberAtom } from '@root/shared/lib'

export const nativePriceByNetwork: Record<Network.Network, BigNumberAtom> = {
  [Network.Ethereum]: reatomBigNumber(0),
  [Network.Base]: reatomBigNumber(0),
  [Network.Solana]: reatomBigNumber(0),
  [Network.Ton]: reatomBigNumber(0),
  [Network.Bsc]: reatomBigNumber(0),
}

export const nativePriceAtom = atom((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)
  const price = nativePriceByNetwork[network]

  return ctx.spy(price)
})

const ENABLED_NETWORK_PAIRS = new Set(
  Network.ENABLED_NETWORKS.map((network) => Network.mainUsdPair(network)),
)

export const initializeNativePricesAction = action((ctx) => {
  const { mainWebsocket } = ctx.get(dependenciesAtom)

  for (const network of Network.ENABLED_NETWORKS) {
    const pairAddress = Network.mainUsdPair(network)
    mainWebsocket.pairPriceSubscribeAction(ctx, {
      pairAddresses: [pairAddress],
      network: network,
    })
  }

  const unsubscribePairPriceEvent = pairPriceUpdateEvent.onCall(
    (ctx, price) => {
      if (!ENABLED_NETWORK_PAIRS.has(price.pairAddress)) {
        return
      }
      if (price.priceUsd.isZero()) {
        return
      }
      const priceAtom = nativePriceByNetwork[price.network]
      priceAtom.set(ctx, price.priceUsd)
    },
  )

  const unsubscribeNetworkData = ctx.subscribe(
    networkDataByNetworkStateAtom,
    (byNetworkState) => {
      if (AsyncStateN.isSuccess(byNetworkState)) {
        for (const network of Network.ENABLED_NETWORKS) {
          const priceAtom = nativePriceByNetwork[network]
          // Only use network data if socket price is faulty
          if (!ctx.get(priceAtom).isZero()) {
            return
          }
          priceAtom.set(ctx, byNetworkState.value[network].nativePrice)
        }
      }
    },
  )

  const _dispose = () => {
    unsubscribePairPriceEvent()
    unsubscribeNetworkData()
  }
}, 'initializeNativePricesAction')
